import React, { useState } from "react";
import { enquiryApi } from "../api/client";

export default function EnquiryForm() {
  const [role, setRole] = useState("Promoter");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "Promoter",
    capacity: "",
    experience: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // ✅ Phone field: allow only numbers & max 10 digits
    if (name === "phone") {
      if (!/^\d*$/.test(value)) return; // only digits allowed
      if (value.length > 10) return; // max length 10
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Extra validation (frontend)
    if (!/^\d{10}$/.test(formData.phone)) {
      alert("❌ Please enter a valid 10-digit phone number!");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      alert("❌ Please enter a valid email address!");
      return;
    }

    try {
      await enquiryApi.submitEnquiry(formData);
      alert("✅ Form submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        role: "Promoter",
        capacity: "",
        experience: "",
        description: "",
      });
      setRole("Promoter");
    } catch (err) {
      console.error(err);
      alert("❌ Error submitting form!");
    }
  };

  return (
    <div className="flex justify-center items-center poppins-regular bg-gray-100 p-4 sm:p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-5 sm:p-8 rounded-2xl shadow-lg w-full max-w-4xl space-y-6"
      >
        <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-800 uppercase tracking-wide">
          Enquiry Form
        </h2>

        {/* Name + Email */}
        <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 sm:gap-6">
          {/* Name */}
          <div className="flex flex-col gap-1">
            <label className="font-medium text-gray-700 text-sm sm:text-base">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            />
          </div>

          {/* Email */}
          <div className="flex flex-col gap-1">
            <label className="font-medium text-gray-700 text-sm sm:text-base">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            />
          </div>
        </div>

        {/* Phone + Role */}
        <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 sm:gap-6">
          {/* Phone */}
          <div className="flex flex-col gap-1">
            <label className="font-medium text-gray-700 text-sm sm:text-base">
              Phone
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Enter 10-digit number"
              maxLength="10"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            />
          </div>

          {/* Role */}
          <div className="flex flex-col gap-1">
            <label className="font-medium text-gray-700 text-sm sm:text-base text-left">
              Role
            </label>
            <select
              name="role"
              value={formData.role}
              onChange={(e) => {
                setRole(e.target.value);
                handleChange(e);
              }}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            >
              <option value="Promoter">Promoter</option>
              <option value="Channel Partner">Channel Partner</option>
            </select>
          </div>
        </div>

        {/* Capacity (Only if Channel Partner) */}
        {role === "Channel Partner" && (
          <div className="flex flex-col gap-1">
            <label className="font-medium text-gray-700 text-sm sm:text-base">
              Capacity
            </label>
            <input
              type="text"
              name="capacity"
              value={formData.capacity}
              onChange={handleChange}
              required
              placeholder="Enter your capacity"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            />
          </div>
        )}

        {/* Experience */}
        <div className="flex flex-col gap-1">
          <label className="font-medium text-gray-700 text-sm sm:text-base">
            Experience
          </label>
          <input
            type="text"
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            required
            placeholder="Enter your experience"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
          />
        </div>

        {/* Description */}
        <div className="flex flex-col gap-1">
          <label className="font-medium text-gray-700 text-sm sm:text-base">
            Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            placeholder="Enter description"
            rows="3"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
          ></textarea>
        </div>

        {/* Submit Button */}
        <div className="flex justify-center">
          <button
            type="submit"
            className="bg-blue-600  text-white px-6 py-2 sm:px-8 sm:py-2 rounded-lg uppercase hover:bg-blue-700 transition font-medium text-sm sm:text-base"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
